module.exports = __webpack_public_path__ + "img/st-9.51edfe93.png";